module.exports = __webpack_public_path__ + "hallway.d6e41d7edb74e81c8e3b.jpg";


//////////////////
// WEBPACK FOOTER
// /Users/Guest/Desktop/Space-Janitor/src/assets/imgs/hallway.jpg
// module id = ../../../../../src/assets/imgs/hallway.jpg
// module chunks = main